module.exports = __webpack_public_path__ + "static/media/bookmark-alt.37308041.svg";